import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ContactEffects } from './contact.effects';
import { contactReducer } from './contact.reducer';

/**
 * Standalone providers for the `contacts` NgRx feature slice (SEOMS-437).
 * Replaces the former `ContactStoreModule`.
 */
export function provideContactsStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState('contacts', contactReducer),
    provideEffects([ContactEffects]),
  ]);
}
